/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_AssigneeInputs */

const en_reports_col_assignee = /** @type {(inputs: Reports_Col_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owner`)
};

const pt_br2_reports_col_assignee = /** @type {(inputs: Reports_Col_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsável`)
};

/**
* | output |
* | --- |
* | "Owner" |
*
* @param {Reports_Col_AssigneeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_assignee = /** @type {((inputs?: Reports_Col_AssigneeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_AssigneeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_assignee(inputs)
	return pt_br2_reports_col_assignee(inputs)
});